// extracted by mini-css-extract-plugin
module.exports = {"form":"itemSearch_form__2XqJr","root":"itemSearch_root__1HtmE"};